import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Paper from '@material-ui/core/Paper';
import * as newProjectActions from '../Actions/newProjectActions';
//import Alert from '@material-ui/lab/Alert';
//import DocumentSelector from "../Components/Orders/DocumentSelector";
//import ComentArea from "../Components/Orders/ComentArea";
//import OptionsSelector from "../Components/Orders/OptionsSelector";
import TaskSelector from "../Components/Orders/TaskSelector";
import LangSelector from "../Components/Orders/LangSelector";
import { orderService } from "../Services/OrderService.js";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import '../Styles/uploadProject.css';
import StepHeader from "../Components/Orders/StepHeader";
import NativeSelect from '@material-ui/core/NativeSelect';
import ClearIcon from '@material-ui/icons/Clear';
import { withTranslation } from 'react-i18next';

//----------------------------------------------------------------
//	UploadOrderContainer
//----------------------------------------------------------------
//	El component representa un document per pujar, i les tasques que se li han de fer.
//	Es responsable de les dependències entre els seus components
//----------------------------------------------------------------

/*
			<DocumentSelector/>
			<ComentArea/>
			<TaskSelectorContainer/>
			<LangSelectorContainer/>
			<OptionsSelector/>
*/

class UploadOrderContainer extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			disabledHelpFile:true,
			extension: ""
			//alerta: false,
		};
		
		this.handleCommentChange = this.handleCommentChange.bind(this);
		this.handleReferenceChange = this.handleReferenceChange.bind(this);
		this.handleDocument = this.handleDocument.bind(this);
		this.handleAttachment = this.handleAttachment.bind(this);
		this.updateTask = this.updateTask.bind(this);
		this.updateLang = this.updateLang.bind(this);
		this.updateLP = this.updateLP.bind(this);
		this.handleUrgentchange = this.handleUrgentchange.bind(this);
		this.handleSpecialchange = this.handleSpecialchange.bind(this);
		this.handleQuotationchange = this.handleQuotationchange.bind(this);
		this.newOrderStep = this.newOrderStep.bind(this);
		this.removeUploadOrderContainer = this.removeUploadOrderContainer.bind(this);
	}

	componentDidMount() {
		//console.log('componentDidMount [UploadOrderContainer]');
	}

	handleCommentChange(e) {
		//console.log('handleCommentChange [UploadOrderContainer ['+this.props.newOrder.id+'] ]: '+e.target.value);
		this.props.actions.updateComment(this.props.newOrder.id, e.target.value);
	}
	handleReferenceChange(e) {
		//console.log('handleReferenceChange [UploadOrderContainer ['+this.props.newOrder.id+'] ]: '+e.target.value);
		this.props.actions.updateReference(this.props.newOrder.id, e.target.value);
	}
	handleDocument(e) {
		//console.log('handleDocument [UploadOrderContainer ['+this.props.newOrder.id+'] ]: '+e.target.value+':'+e.target.files[0]);
		let extension = e.target.files[0].name.slice((e.target.files[0].name.lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase();
		//console.log("extension: "+extension);
		if (['txt', 'docx', 'xlsx', 'idml', 'html', 'po', 'pdf', 'pptx', 'odt', 'mov', 'mp4', 'properties', 'jpg', 'png', 'json', 'xml', 'wav', 'xlf'].indexOf(extension) >= 0) {
			//this.setState({disabledHelpFile: false, alerta: false});
			this.setState({disabledHelpFile: false, extension: extension});
			this.props.actions.updateAlert(this.props.newOrder.id, false);
			this.props.actions.updateDocument(this.props.newOrder.id, e.target.files[0]);
		}else{
			e.target.value = '';
			this.setState({disabledHelpFile: true, extension: extension});
			this.props.actions.updateAlert(this.props.newOrder.id, true);
		}
		
	}
	handleAttachment(e){
		//console.log('handleAttachment [UploadOrderContainer ['+this.props.newOrder.id+'] ]: '+e.target.value);
		this.props.actions.updateAttachment(this.props.newOrder.id, e.target.files[0]);
	}
	
	updateTask(task, checked){
		//console.log('updateTask ['+task+']:  '+checked);
		this.props.actions.updateTask(this.props.newOrder.id, task, checked);
	}
	
	updateLang(lang, checked){
		//console.log('updateLang ['+lang+']:  '+checked);
		this.props.actions.updateLang(this.props.newOrder.id, lang, checked);
	}
	
	updateLP(task, idLP, checked){
		//console.log('updateLP ['+task+', '+idLP+']:  '+checked);
		this.props.actions.updateLP(this.props.newOrder.id, task, idLP, checked);
	}
	
	handleUrgentchange(e) {
		//console.log('handleUrgentchange: '+e.target.checked);
		this.props.actions.updateUrgent(this.props.newOrder.id, e.target.checked);
	}
	handleSpecialchange(e) {
		//console.log('handleSpecialchange:  '+e.target.checked);
		this.props.actions.updateSpecial(this.props.newOrder.id, e.target.checked);
	}
	handleQuotationchange(e) {
		//console.log('handleQuotationchange:  '+e.target.checked);
		this.props.actions.updateQuotation(this.props.newOrder.id, e.target.checked);
	}
	
	newOrderStep(WrappedComponent) {
		return class extends React.Component {
			constructor(props){
				//console.log('newOrderStep: ', this.props);
			}
			componentWillReceiveProps(nextProps) {
				//console.log('Current props: ', this.props);
				//console.log('Next props: ', nextProps);
			}
			render() {
				return(
					<div>
					<div>{this.props.stepIndex} - {this.props.stepTitle}</div>
					<WrappedComponent {...this.props} />;
					</div>
				)
			}
		}
	}
	
	removeUploadOrderContainer(){
		this.props.removeUploadOrderContainer(this.props.newOrder.id);
	}

/*			<Button label="Choose attachment" margin="normal" component="span">
					<input type="file" name="attachment" onChange={this.handleAttachment}/>
			</Button>
*/
	
	render() {
		const { t } = this.props;
		//console.log('render [UploadOrderContainer]: ' + JSON.stringify(this.props.newOrder));
		//if(!this.props.newOrder.enabled){
		//	return "";
		//}
		let lstProducts = this.props.user.customer.product.sort( (a, b) => a.langPair.code.localeCompare(b.langPair.code) );
		
		let lstTasks = this.props.user.customer.product.reduce(function(acc, value) {
			let task=value.task;
			//console.log('lstTasks ?= '+value.task+"_"+value.langPair.code+" ["+value.id+"]");
			if((!acc.includes(task)) && (task!="revision")){
				acc.push(task);
				//console.log('lstTasks <= '+task);
			}else{
				//console.log('lstTasks |< '+task);
			}
			return acc;
		},[]).sort((a, b)=>a.localeCompare(b));
//		let lstLang = this.props.user.customer.product.sort( (a, b) => a.langPair.code.localeCompare(b.langPair.code) );
		
		let lstLang = this.props.user.customer.product.filter(function(element){
			return ((this.props.newOrder.task.length>0) && (element.task === this.props.newOrder.task[0]) );
		}, this).sort( (a, b) => a.langPair.code.localeCompare(b.langPair.code) );
		
		//let alerta = this.state.alerta && <Grid><Alert severity="error" onClose={() => {this.setState({alerta: false})}}>Formato no soportado | Format not supported</Alert></Grid>;
		let alerta = this.props.newOrder.alerta && <Grid><div className="error">{t('format_unsuport')}</div></Grid>;
		
		//console.log(this.props.newOrder.enabled);
		let clase = this.props.newOrder.enabled ? "uploadDoc" : "uploadDocDisabled"
		//console.log(clase);
		return (
			<div className={clase}>
			<Grid container direction="row" alignItems="flex-start" justify="center" spacing={2}>
				<Grid container item direction="column" alignItems="flex-start" justify="center" spacing={2} xs={5}>
					<Grid container item direction="row" alignItems="flex-start" justify="center" spacing={2} xs={5}>
						<Grid item>
							<StepHeader index={this.props.index+1} title={t('select_doc')} active={true} first={true}/>
						</Grid>
						<Grid item>
							<div className="step_header"><ClearIcon style={{color: "#f00", cursor: "pointer"}} onClick={this.removeUploadOrderContainer} /></div>
						</Grid>
					</Grid>
					<Grid container item direction="row" alignItems="flex-start" justify="center" spacing={0}>
					<Grid item xs={12}>
					<Grid>{t('src_file')}</Grid>
					{alerta}
					<Paper>
						<Grid>
						<Button label={t('choose_file')} component="span">
								<input type="file" name="docuemnt" style={{ overflow: 'hidden' }} onChange={this.handleDocument}/>
						</Button>
						</Grid>
					</Paper>
					</Grid></Grid>
					<Grid container item direction="row" alignItems="flex-start" justify="center" spacing={0}>
					<Grid item xs={12}>
					<Paper>
						<TextField
							id={"reference_"+this.props.newOrder.id}
							name={"reference_"+this.props.newOrder.id}
							label={t('reference')}
							defaultValue=""
							value={this.props.newOrder.reference}
							onChange={this.handleReferenceChange}
						/>
					</Paper>
					</Grid></Grid>
					<Grid container item direction="row" alignItems="flex-start" justify="center" spacing={0}>
					<Grid item xs={12}>
					<Paper>
						<TextField
							id={"comments_"+this.props.newOrder.id}
							name={"comments_"+this.props.newOrder.id}
							label={t('comments')}
							defaultValue=""
							value={this.props.newOrder.comment}
							multiline
							onChange={this.handleCommentChange}
						/>
					</Paper>
					</Grid></Grid>
					<Grid container item direction="row" alignItems="flex-start" justify="center" spacing={0}>
					<Grid item xs={12}>
					<Grid>{t('help_file')}</Grid>
					<Paper>
						<Button label={t('choose_attch')} component="span">
							<input type="file" name="attachment" style={{ overflow: 'hidden' }} onChange={this.handleAttachment} disabled = {(this.state.disabledHelpFile)? "disabled" : ""}/>
						</Button>
					</Paper>
					</Grid></Grid>
				</Grid>
				<Grid container item direction="row" alignItems="flex-start" justify="center" spacing={0} xs={2}>
					<TaskSelector	product={lstTasks}
									updateTask={this.updateTask}
									index = {this.props.newOrder.id}
									stepIndex = {2}
									stepTitle = {t('select_service')}
									extension = {this.state.extension}/>
				</Grid>
				<Grid container item direction="row" alignItems="flex-start" justify="center" spacing={0} xs={3}>
					<LangSelector	product={lstLang}
									updateLang={this.updateLang}
									index = {this.props.newOrder.id}
									stepIndex = {3}
									stepTitle = {t('select_lang')}/>
				</Grid>
				<Grid container item direction="column" alignItems="flex-start" justify="center" spacing={0} xs={2}>
					<StepHeader index={4} title={t('more_options')} active={true} first={false}/>
					<Grid item  xs={12}>
						<FormControlLabel
							control={
								<Checkbox
									defaultChecked={this.props.newOrder.urgent}
									value="urgent"
									color="primary"
									name="urgent"
									onChange={this.handleUrgentchange}
								/>
							}
						label={t('urgent')}
						/>
					</Grid>
					<Grid item  xs={12}>
						<FormControlLabel
							control={
								<Checkbox
									defaultChecked={this.props.newOrder.special}
									value="special"
									color="primary"
									name="special"
									onChange={this.handleSpecialchange}
								/>
							}
							label={t('special')}
						/>
					</Grid>
				</Grid>
			</Grid>
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	//console.log('mapStateToProps [UploadOrderContainer]: ' + JSON.stringify(state.newProject.find((e) => e.id === ownProps.id)));
	return {user: state.user, newOrder: state.newProject.find((e) => e.id === ownProps.id)}
}
function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(newProjectActions, dispatch)}
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation() (UploadOrderContainer));  